let baseURL = window.location.origin;

//Workaround only for development with react on node.js server
if (window.location.hostname === 'localhost') {
  const location = window.location;
  baseURL = location.protocol + "//" + location.hostname + ':9091';
}

export const AXIOS_BASE_CONFIG = {
  baseURL: baseURL,
  //Automatically send cookies cross-origin, workaround only for development with react on node.js server
  withCredentials: process.env.NODE_ENV === 'development',
};

export const AUTHORIZATION_HEADER_NAME = "Authorization";

const BACKEND_BASE_PATH = '/api';

export const BACKEND_PATHS = {
  configuration: BACKEND_BASE_PATH + '/configuration',
  login:         BACKEND_BASE_PATH + '/login',
  autoLogin:     BACKEND_BASE_PATH + '/login/auto',
  clearCookies:  BACKEND_BASE_PATH + '/login/clearCookies',
  updateCookies: BACKEND_BASE_PATH + '/login/updateCookies',
  reports:       '/conf/reports.json', //This is file not endpoint, don't use BASE_PATH there
};

/**
 * <pre>
 * Object of paths that send REST directly from frontend to gateway
 *
 * It will be filled automatically in the 'App.js' using paths returned from backend
 * Keys of this object are the same as names of fields in 'FrontEndPathsConfiguration.java'
 * </pre>
 *
 * @type {Object.<String>}
 */
export const FINTECH_PATHS = {};

/**
 * <pre>
 * Object of hidden tabs on navBar
 *
 * It will be filled automatically in the 'App.js' using values returned from backend
 * Keys of this object are the same as names of fields in 'FrontEndHideTabsConfiguration.java'
 * </pre>
 *
 * @type {Object.<String>}
 */
export const HIDDEN_TABS = {};

/**
 *  Numer of rows per page in infinite scroll tables.
 */
export let OTHER_CONFIG = {};